<template>
  <div class="register absolute">
    <div class="register_tit">
      <img @click="handleBack" src="../../assets/images/licai/fanhui.png" />
      <p>{{ purchaseStep === "payment" ? "确认支付" : "产品认购" }}</p>
    </div>

    <div class="register_block" style="padding:10px;">
      <div class="purchase-production-hero">
        <img
          src="../../assets/images/asm-premium/advanced-packaging-fab.webp"
          alt="ASM半导体生产车间"
        />
      </div>

      <div
        style="border-radius:6px; height:70px;width: 100%; margin-top:10px;background-color:#fff;display:flex;align-items:center;justify-content: space-between;padding:0 10px;"
      >
        <span style="font-size:16px;"
          >{{ dicdata.tag }}{{ dicdata.title }}</span
        >
        <div>
          <p style="color: var(--bg-color);font-size:14px;">
            <span style="font-size:24px;">{{ formatPercent(dicdata.rate) }}</span
            >%
          </p>
          <!-- <p style="font-size:12px;color:#999;">日回报率</p> -->
        </div>
      </div>

      <div
        v-if="purchaseStep === 'amount'"
        style="border-radius:6px;width: 100%; margin-top:10px;background-color:#fff;padding:15px 10px;padding-bottom:0;"
      >
        <!-- <span style="font-size:16px;">{{$t('m.tz_span4')}}</span> -->
        <div
          style="display:flex;align-items:center; font-size:26px;font-weight:bold;padding-left:10px;margin-top:0px;line-height:50px;"
        >
          <span style="font-size:15px;width: 50px;">金额</span>
          <input
            readonly="readonly"
            style="margin-left:0px;border-bottom:1px solid #eee;"
            @click="show = true"
            v-model="money"
            autocomplete="off"
          />
          <span style="font-size:14px;color:#666;margin-left:8px;">USD</span>
        </div>
      </div>
      <div
        v-if="purchaseStep === 'amount'"
        style="border-radius:6px; height:50px;width: 100%; margin-top:10px;background-color:#fff;display:flex;align-items:center;justify-content: space-between;padding:0 10px;"
      >
        <span style="font-size:16px;flex:1;">{{ $t("m.yue") }}</span>
        <div style="width: 170px;">
          <p style="font-size:14px;text-align:right;padding-right:10px;">
            {{ formatAmount(ktxje) }} USD
          </p>
        </div>
      </div>
      <template v-if="purchaseStep === 'amount'">
        <div class="purchase-flow-hint">
          <span>1</span>
          <p><strong>确认投资金额</strong><small>下一步阅读并签署保本保息电子合同</small></p>
        </div>
        <van-button class="register_submit" type="info" @click="startContractStep">
          立即购买
        </van-button>
        <div class="purchase-range">
          投资范围
          <span>{{ formatAmount(qi) }}</span> USD -
          <span>{{ formatAmount(gao) }}</span> USD，限投
          <span>{{ dicdata.mcount }}</span> 次
        </div>
      </template>

      <section v-if="purchaseStep === 'payment'" class="payment-step-card">
        <div class="step-kicker">最后一步</div>
        <h2>输入支付密码</h2>
        <p class="payment-lead">合同已确认并完成手写签名，请核对订单后支付。</p>
        <div class="payment-order-summary">
          <p><span>购买项目</span><strong>{{ dicdata.title || "--" }}</strong></p>
          <p><span>投资金额</span><strong>{{ formatAmount(money) }} USD</strong></p>
          <p><span>项目期限</span><strong>{{ dicdata.day || "--" }} 天</strong></p>
          <p><span>返利方式</span><strong>{{ repaymentDescription }}</strong></p>
        </div>
        <div class="signed-contract-status">
          <span>✓</span>
          <p><strong>保本保息电子合同已签署</strong><small>签名仅用于本次订单</small></p>
        </div>
        <label class="password-field">
          <span>支付密码</span>
          <input
            type="password"
            v-model="mima"
            autocomplete="off"
            placeholder="请输入支付密码"
          />
        </label>
        <div class="payment-balance">
          <span>账户余额</span>
          <strong>{{ formatAmount(ktxje) }} USD</strong>
        </div>
        <van-button
          class="register_submit payment-submit"
          type="info"
          :disabled="shows"
          @click="registerReset(dicdata.id)"
        >确认支付</van-button>
      </section>
    </div>

    <div style="height: 100px;width: 100%;"></div>
    <!-- <div style="width: 92%;
  margin: 20px auto;color: #666;font-size:12px;display:flex;align-items:center;" >
        <img style="width: 14px;height: 14px;margin-right:4px;" src="../../assets/images/licai/shangcheng.png" alt="">
        通过注册，代表你同意我们的使用条款和条件
    </div> -->
    <van-number-keyboard
      :show="show && purchaseStep === 'amount'"
      theme="custom"
      extra-key="."
      :close-button-text="$t('m.finish')"
      @blur="show = false"
      @input="onInput"
      @delete="onDelete"
    />
    <div v-if="purchaseStep === 'contract'" class="contract-full-page">
      <header class="contract-page-header">
        <button type="button" @click="cancelContractStep">‹</button>
        <div>
          <strong>保本保息电子合同</strong>
          <small>请完整阅读并在本页底部签名</small>
        </div>
        <span>2/3</span>
      </header>
      <main class="contract-page-content">
        <article class="contract-document">
          <header class="contract-document-title">
          <div>
            <small>PRINCIPAL &amp; AGREED INCOME PROTECTION AGREEMENT</small>
              <h2>保本保息电子合同</h2>
              <p>本金及约定收益保障协议</p>
          </div>
          </header>
        <section class="contract-summary">
          <p><span>产品名称</span><strong>{{ dicdata.title || "--" }}</strong></p>
          <p><span>购买金额</span><strong>{{ formatAmount(money) }} USD</strong></p>
          <p><span>保障期限</span><strong>{{ dicdata.day || "--" }} 天</strong></p>
          <p><span>返利方式</span><strong>{{ repaymentDescription }}</strong></p>
        </section>
        <section class="contract-copy">
          <h3>第一条　合同与订单确认</h3>
          <p>本合同与本次认购订单唯一绑定。产品名称、购买金额、实际收益率、期限、结算方式、实名信息、支付记录及本人电子签名共同构成合同记录。</p>
          <h3>第二条　本金及约定收益保障</h3>
          <p>合同义务人按照订单锁定的本金、收益率、期限和结算方式承担给付责任。合同到期且不存在依法应暂停结算的情形时，应完成本金及尚未支付约定收益的结算。</p>
          <h3>第三条　收益计算与兑付</h3>
          <p>基础约定收益＝投入本金 × 实际日化收益率 × 合同计息天数。按日返息产品在完整计息周期后结息、到期返本；到期返本返息产品在到期日统一结算。</p>
          <h3>第四条　双方权利与义务</h3>
          <p>本人应使用真实身份与本人账户完成认购并妥善保管密码。合同义务人应保存订单、签署及结算记录，不得在合同生效后单方降低本订单锁定的本金、收益率或期限。</p>
          <h3>第五条　异常处理</h3>
          <p>身份异常、司法冻结、反洗钱审查或账户被盗风险发生时，可在必要范围内暂停操作并要求核验。系统维护或网络故障造成暂时延迟的，不当然免除已经产生的合同给付义务。</p>
          <h3>第六条　违约责任</h3>
          <p>任一方违反合同并造成对方实际损失的，应依法承担相应责任。无正当理由未按约完成结算时，本人有权要求继续履行并依法主张权利。</p>
          <h3>第七条　电子签名与证据</h3>
          <p>本人确认使用本次手写电子签名签署。系统将保存签署时间、签名校验值、IP及设备信息，用于识别签署人并验证合同完整性；再次购买必须重新阅读和签署。</p>
          <h3>第八条　争议解决与生效</h3>
          <p>争议应先协商处理，协商不成时可依法向有管辖权的人民法院提起诉讼。本合同在本人完成实名核验、勾选同意、提交电子签名且订单支付成功后生效。</p>
        </section>
          <section class="contract-signature-section">
            <div class="signature-heading">
              <div>
                <h3>本人手写签名</h3>
                <p>请使用手指或触控笔，在下方完整签写本人姓名</p>
              </div>
              <span>本次订单专用</span>
            </div>
            <SignaturePad ref="contractSignaturePad" />
            <label class="contract-agreement">
              <input type="checkbox" v-model="contractAgreed" />
              <i aria-hidden="true">{{ contractAgreed ? "✓" : "" }}</i>
              <span>本人已完整阅读、理解并同意本合同全部条款，确认以本人手写电子签名签署。</span>
            </label>
          </section>
        </article>
      </main>
      <footer class="contract-page-footer">
        <button
          type="button"
          :disabled="signatureUploading"
          @click="confirmContractAndContinue"
        >{{ signatureUploading ? "正在保存签名..." : "确认合同并继续" }}</button>
      </footer>
    </div>
    <div
      v-if="purchaseSuccessVisible"
      class="purchase-success-mask"
      role="dialog"
      aria-modal="true"
      aria-labelledby="purchase-success-title"
    >
      <section class="purchase-success-dialog">
        <div class="purchase-success-icon" aria-hidden="true">✓</div>
        <h2 id="purchase-success-title">购买成功</h2>
        <p>订单已提交，本金及约定收益保障电子合同已完成签署。</p>
        <button type="button" @click="confirmPurchaseSuccess">确定</button>
      </section>
    </div>
    <div
      v-if="shows"
      style="background: rgba(0, 0, 0, 0.5);position: fixed;width: 100%;height: 100%;left:0;top:0;display: flex;align-items: center;justify-content: center;"
    >
      <div
        style="background: rgba(0, 0, 0, 0.7);width:130px;height:130px;border-radius:8px;text-align:center;line-height:130px;color:#fff;font-size:16px;"
      >
        {{ $t("m.tijiaoing") }}
      </div>
    </div>
  </div>
</template>

<script>
import request from "@utils/request";
import { getMyUserInfo } from "../../api/user";
import { auth_upload } from "@api/chat";
import SignaturePad from "@/components/SignaturePad";
export default {
  name: "GoodsPay",
  components: { SignaturePad },
  data: function() {
    return {
      shows: false,
      show: false,
      money: "",
      qi: 0,
      gao: 0,
      mima: "",
      dicdata: {},
      dangqian: 0,
      ktxje: 0,
      huilv: 1,
      ktxje1: 0,
      purchaseStep: "amount",
      contractAgreed: false,
      contractSignature: "",
      signatureUploading: false,
      purchaseSuccessVisible: false,
      purchasedOrderId: null
    };
  },

  mounted: function() {
    this.dangqian = 0;
    getMyUserInfo().then(res => {
      console.log(res.data, res.data.data.money);
      this.ktxje = res.data.data.money;
      this.ktxje1 = res.data.data.money;
      if (res.data.data.is_auth != 1) {
        this.$dialog.message("请先完成实名认证");
        this.$router.push({ name: "memmber_business" });
      }
    });
    let type = this.$route.params.id;
    console.log("传参");
    console.log(type);
    // this.$nextTick(function() {
      request
      .get("/fund/project/detail", { id: type }, { login: false })
      .then(res => {
        console.log(res.data.data);
        this.dicdata = res.data.data;
        if (this.isProjectNotStarted(this.dicdata)) {
          this.$dialog.message("项目未开启");
          this.$router.replace({ path: "/detail/" + type });
          return;
        }
        if (this.isProjectFull(this.dicdata)) {
          this.$dialog.message("项目已满仓");
          this.$router.replace({ path: "/detail/" + type });
          return;
        }
        this.money = this.formatAmount(this.dicdata.min);
        this.qi = this.formatAmount(this.dicdata.min);
        this.gao = this.formatAmount(this.dicdata.max);
      })
      .catch(err => {
        this.$dialog.error(err.response.data.msg);
      });
    // });
  },
  methods: {
    handleBack() {
      if (this.purchaseStep === "payment") {
        this.resetPurchaseFlow();
        return;
      }
      this.$router.go(-1);
    },
    resetPurchaseFlow() {
      this.purchaseStep = "amount";
      this.contractAgreed = false;
      this.contractSignature = "";
      this.mima = "";
      this.show = false;
      window.scrollTo(0, 0);
    },
    cancelContractStep() {
      this.resetPurchaseFlow();
    },
    validatePurchaseAmount() {
      if (this.isProjectNotStarted(this.dicdata)) {
        this.$dialog.message("项目未开启");
        return false;
      }
      if (this.isProjectFull(this.dicdata)) {
        this.$dialog.message("项目已满仓");
        return false;
      }
      const amount = Number(this.money);
      const minimum = Number(this.dicdata.min);
      const maximum = Number(this.dicdata.max);
      if (!Number.isFinite(amount) || amount <= 0) {
        this.$dialog.message("请输入正确的购买金额");
        return false;
      }
      if (Number.isFinite(minimum) && amount < minimum) {
        this.$dialog.message("购买金额最低 " + this.formatAmount(minimum) + " USD");
        return false;
      }
      if (Number.isFinite(maximum) && amount > maximum) {
        this.$dialog.message("购买金额最高 " + this.formatAmount(maximum) + " USD");
        return false;
      }
      if (amount > Number(this.ktxje)) {
        this.$dialog.message("账户余额不足");
        return false;
      }
      return true;
    },
    startContractStep() {
      if (!this.validatePurchaseAmount()) {
        return;
      }
      this.show = false;
      this.contractAgreed = false;
      this.contractSignature = "";
      this.purchaseStep = "contract";
      this.$nextTick(() => window.scrollTo(0, 0));
    },
    async confirmContractAndContinue() {
      if (!this.contractAgreed) {
        this.$dialog.message("请先勾选同意本次保本保息电子合同");
        return;
      }
      if (!this.$refs.contractSignaturePad || !this.$refs.contractSignaturePad.isValid()) {
        this.$dialog.message("请在签名框内完整手写本人姓名");
        return;
      }
      this.signatureUploading = true;
      try {
        const signatureBlob = await this.$refs.contractSignaturePad.exportBlob();
        const signatureData = new FormData();
        signatureData.append("file", signatureBlob, "contract-signature.png");
        signatureData.append("side", "contract_signature");
        const uploadResponse = await auth_upload(signatureData);
        const signatureUrl =
          uploadResponse && uploadResponse.data && uploadResponse.data.data
            ? uploadResponse.data.data.url
            : "";
        if (!signatureUrl) {
          throw new Error("签名保存失败，请重新签名");
        }
        this.contractSignature = signatureUrl;
        this.purchaseStep = "payment";
        this.mima = "";
        this.$nextTick(() => window.scrollTo(0, 0));
      } catch (err) {
        const message =
          (err.response && err.response.data && err.response.data.msg) ||
          err.message ||
          "签名保存失败，请稍后重试";
        this.$dialog.error(message);
      } finally {
        this.signatureUploading = false;
      }
    },
    confirmPurchaseSuccess() {
      const orderId = this.purchasedOrderId;
      this.purchaseSuccessVisible = false;
      this.$router.replace({
        path: orderId ? "/Contract" : "/myInvest",
        query: orderId ? { id: orderId } : {}
      });
    },
    formatAmount(value) {
      const num = Number(value);
      if (Number.isNaN(num)) {
        return value || "0.00";
      }
      return num.toFixed(2);
    },
    formatPercent(value) {
      const num = Number(value);
      if (Number.isNaN(num)) {
        return value || "0.00";
      }
      return num.toFixed(2);
    },
    isProjectFull(item) {
      if (!item) {
        return false;
      }
      return Number(item.status) == 2 || Number(item.schedule) >= 100;
    },
    isProjectNotStarted(item) {
      return item && Number(item.status) == 0;
    },
    onInput(value) {
      let vm = this;
      this.money = vm.money + value;
    },
    onDelete() {
      console.log("sdsdsa");
      this.money = this.money.slice(0, this.money.length - 1);
    },
    async registerReset(e) {
      if (this.purchaseStep !== "payment" || !this.validatePurchaseAmount()) {
        return;
      }
      if (this.mima.length <= 0) {
        this.$dialog.message("请输入支付密码");
        return;
      }
      if (!this.contractAgreed || !this.contractSignature) {
        this.$dialog.message("请先完成保本保息电子合同签署");
        return;
      }
      this.shows = true;
      localStorage.setItem(
        "shu",
        JSON.stringify({ money: this.money, name: this.dicdata.title })
      );
      try {
        const res = await request.post(
          "/fund/add",
          {
            id: e,
            pwd: this.mima,
            money: this.money,
            contract_agreed: 1,
            contract_signature: this.contractSignature
          },
          { login: true }
        );
        const orderId = res.data.data && res.data.data.order_id;
        this.purchasedOrderId = orderId || null;
        this.purchaseSuccessVisible = true;
      } catch (err) {
        const message =
          (err.response && err.response.data && err.response.data.msg) ||
          err.message ||
          "提交失败，请稍后重试";
        this.$dialog.error(message);
      } finally {
        this.shows = false;
      }
    }
  },
  computed: {
    repaymentDescription() {
      const value = String(this.dicdata.payment_desc || "");
      if (/到期.*本.*息|本息.*到期/.test(value)) {
        return "到期返本返息";
      }
      if (/按天|按日|每日/.test(value)) {
        return "按日返息，到期返本";
      }
      return value || "按日返息，到期返本";
    }
  }
};
</script>
<style scoped>
.register_submit {
  width: 100%;
  margin: 0 auto;
  height: 45px;
  background: var(--bg-color);
  border-radius: 30px;
  margin-top: 40px;
  text-align: center;
  line-height: 45px;
  color: #ffffff;
  border: 0px solid;
  font-size: 15px;
  font-weight: bold;
}

.register_block {
  padding: 0;
}
.purchase-production-hero {
  position: relative;
  width: 100%;
  height: 132px;
  overflow: hidden;
  border-radius: 10px;
  background: #0b3158;
  box-shadow: 0 8px 22px rgba(11, 49, 88, 0.14);
}
.purchase-production-hero::after {
  position: absolute;
  inset: 0;
  content: "";
  pointer-events: none;
  background: linear-gradient(90deg, rgba(4, 35, 66, 0.22), transparent 58%);
}
.purchase-production-hero img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center 54%;
}
.contract-card {
  margin-top: 10px;
  padding: 16px 14px;
  background: #fff;
  border-radius: 10px;
}
.contract-title {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding-bottom: 12px;
  border-bottom: 1px solid #eef0f4;
}
.contract-title strong {
  color: #202534;
  font-size: 17px;
}
.contract-title p {
  margin-top: 5px;
  color: #8b93a1;
  font-size: 12px;
}
.contract-read-button {
  padding: 4px 9px;
  color: #1769b0;
  background: #e8f3fb;
  border: 0;
  border-radius: 12px;
  font-size: 12px;
}
.contract-terms {
  padding: 8px 0;
}
.contract-terms p {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  padding: 7px 0;
  font-size: 13px;
}
.contract-terms span {
  color: #8a909d;
}
.contract-terms strong {
  color: #303544;
  text-align: right;
}
.contract-agreement {
  display: flex;
  align-items: flex-start;
  padding: 10px;
  color: #555d6d;
  background: #f5f7fb;
  border-radius: 8px;
  font-size: 12px;
  line-height: 1.6;
}
.contract-agreement input {
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
}
.contract-agreement i {
  display: inline-flex;
  width: 19px;
  height: 19px;
  margin: 1px 9px 0 0;
  flex: none;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 14px;
  font-style: normal;
  font-weight: 800;
  background: #fff;
  border: 1.5px solid #9aa8ba;
  border-radius: 5px;
}
.contract-agreement input:checked + i {
  background: #1769b0;
  border-color: #1769b0;
}
.contract-inline-link {
  display: block;
  margin: 8px 0 0 auto;
  padding: 4px 0;
  color: #1769b0;
  border: 0;
  background: transparent;
  font-size: 12px;
}
.signature-label {
  margin: 14px 0 8px;
  color: #303544;
  font-size: 14px;
  font-weight: bold;
}
.signature-note {
  margin-top: 8px;
  color: #a47730;
  font-size: 12px;
}
.contract-viewer {
  position: fixed;
  z-index: 1200;
  inset: 0;
  display: flex;
  align-items: flex-end;
  background: rgba(8, 22, 41, 0.58);
}
.contract-viewer > article {
  width: 100%;
  max-height: 88vh;
  padding: 20px 17px calc(18px + env(safe-area-inset-bottom));
  overflow-y: auto;
  background: #fff;
  border-radius: 22px 22px 0 0;
}
.contract-viewer header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}
.contract-viewer header small {
  color: #6d8fb3;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 1px;
}
.contract-viewer header h2 {
  margin-top: 5px;
  color: #202b3a;
  font-size: 21px;
}
.contract-viewer header button {
  width: 34px;
  height: 34px;
  color: #7e8997;
  border: 0;
  background: #f0f3f7;
  border-radius: 50%;
  font-size: 24px;
}
.contract-summary {
  margin: 16px 0;
  padding: 11px 13px;
  background: #f3f7fb;
  border-radius: 12px;
}
.contract-summary p {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  padding: 6px 0;
  color: #7a8593;
  font-size: 12px;
}
.contract-summary strong {
  color: #263446;
  text-align: right;
}
.contract-copy h3 {
  margin: 15px 0 5px;
  color: #263446;
  font-size: 14px;
}
.contract-copy p {
  color: #697688;
  font-size: 12px;
  line-height: 1.75;
}
.purchase-flow-hint {
  display: flex;
  align-items: center;
  gap: 11px;
  margin-top: 14px;
  padding: 12px 14px;
  background: #edf5fb;
  border-radius: 10px;
}
.purchase-flow-hint > span {
  display: flex;
  width: 28px;
  height: 28px;
  flex: none;
  align-items: center;
  justify-content: center;
  color: #fff;
  background: #1769b0;
  border-radius: 50%;
  font-weight: 700;
}
.purchase-flow-hint p {
  display: flex;
  flex-direction: column;
  color: #26384b;
  font-size: 13px;
}
.purchase-flow-hint small {
  margin-top: 3px;
  color: #75879a;
  font-size: 11px;
}
.purchase-range {
  padding: 14px 10px 0;
  color: #6b7684;
  font-size: 13px;
  line-height: 1.7;
}
.purchase-range span {
  color: #1769b0;
  font-weight: 600;
}
.payment-step-card {
  margin-top: 12px;
  padding: 20px 15px;
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 8px 24px rgba(30, 63, 94, 0.07);
}
.step-kicker {
  color: #1769b0;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 1px;
}
.payment-step-card h2 {
  margin: 5px 0 4px;
  color: #213247;
  font-size: 22px;
}
.payment-lead {
  color: #7b8796;
  font-size: 12px;
}
.payment-order-summary {
  margin: 17px 0 12px;
  padding: 10px 13px;
  background: #f4f7fa;
  border-radius: 10px;
}
.payment-order-summary p,
.payment-balance {
  display: flex;
  justify-content: space-between;
  gap: 18px;
  padding: 7px 0;
  color: #7b8795;
  font-size: 13px;
}
.payment-order-summary strong,
.payment-balance strong {
  color: #26384b;
  text-align: right;
}
.signed-contract-status {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 12px 0;
  padding: 12px;
  color: #245d4a;
  background: #edf8f3;
  border-radius: 10px;
}
.signed-contract-status > span {
  display: flex;
  width: 28px;
  height: 28px;
  flex: none;
  align-items: center;
  justify-content: center;
  color: #fff;
  background: #31866a;
  border-radius: 50%;
  font-weight: 700;
}
.signed-contract-status p {
  display: flex;
  flex-direction: column;
  font-size: 13px;
}
.signed-contract-status small {
  margin-top: 2px;
  color: #6f9385;
  font-size: 11px;
}
.password-field {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-top: 16px;
  padding: 0 12px;
  border: 1px solid #dce4ec;
  border-radius: 10px;
}
.password-field span {
  color: #34465a;
  font-size: 14px;
  white-space: nowrap;
}
.password-field input {
  width: 100%;
  height: 52px;
  color: #26384b;
  border: 0;
  background: transparent;
  font-size: 15px;
  outline: none;
}
.payment-balance {
  padding: 14px 4px 0;
}
.payment-submit {
  margin-top: 24px;
}
.contract-full-page {
  position: fixed;
  z-index: 1250;
  inset: 0;
  display: flex;
  flex-direction: column;
  background: #eef3f7;
}
.contract-page-header {
  display: grid;
  grid-template-columns: 38px 1fr 38px;
  align-items: center;
  min-height: 62px;
  padding: env(safe-area-inset-top) 12px 0;
  background: #fff;
  border-bottom: 1px solid #e8edf2;
}
.contract-page-header button {
  width: 34px;
  height: 34px;
  color: #304459;
  border: 0;
  background: transparent;
  font-size: 32px;
  line-height: 30px;
}
.contract-page-header div {
  display: flex;
  flex-direction: column;
  text-align: center;
}
.contract-page-header strong {
  color: #213247;
  font-size: 16px;
}
.contract-page-header small {
  margin-top: 2px;
  color: #8793a1;
  font-size: 10px;
}
.contract-page-header > span {
  color: #1769b0;
  font-size: 12px;
  text-align: right;
}
.contract-page-content {
  flex: 1;
  overflow-y: auto;
  padding: 12px 10px 24px;
  -webkit-overflow-scrolling: touch;
}
.contract-document {
  max-width: 760px;
  margin: 0 auto;
  padding: 22px 16px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 28px rgba(29, 58, 87, 0.07);
}
.contract-document-title {
  padding-bottom: 15px;
  border-bottom: 1px solid #e8edf2;
}
.contract-document-title small {
  color: #6b8dad;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 1px;
}
.contract-document-title h2 {
  margin: 7px 0 2px;
  color: #1f3044;
  font-size: 23px;
}
.contract-document-title p {
  color: #84909d;
  font-size: 11px;
}
.contract-signature-section {
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid #e3e9ef;
}
.signature-heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 10px;
}
.signature-heading h3 {
  color: #26384b;
  font-size: 16px;
}
.signature-heading p {
  margin-top: 4px;
  color: #7c8997;
  font-size: 11px;
}
.signature-heading > span {
  padding: 4px 8px;
  color: #8b6527;
  background: #fff6e4;
  border-radius: 12px;
  font-size: 10px;
  white-space: nowrap;
}
.contract-signature-section .contract-agreement {
  margin-top: 12px;
}
.contract-page-footer {
  padding: 10px 14px calc(10px + env(safe-area-inset-bottom));
  background: #fff;
  border-top: 1px solid #e5ebf0;
}
.contract-page-footer button {
  width: 100%;
  height: 46px;
  color: #fff;
  border: 0;
  background: #1769b0;
  border-radius: 24px;
  font-size: 15px;
  font-weight: 700;
}
.contract-page-footer button:disabled {
  opacity: 0.65;
}
.purchase-success-mask {
  position: fixed;
  z-index: 1300;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(8, 22, 41, 0.58);
}
.purchase-success-dialog {
  width: min(330px, 100%);
  padding: 28px 22px 20px;
  text-align: center;
  background: #fff;
  border-radius: 18px;
  box-shadow: 0 22px 60px rgba(8, 32, 58, 0.24);
}
.purchase-success-icon {
  width: 58px;
  height: 58px;
  margin: 0 auto 14px;
  color: #fff;
  background: linear-gradient(145deg, #2d83c3, #1769b0);
  border-radius: 50%;
  box-shadow: 0 10px 24px rgba(23, 105, 176, 0.25);
  font-size: 32px;
  line-height: 58px;
}
.purchase-success-dialog h2 {
  margin: 0;
  color: #203448;
  font-size: 21px;
}
.purchase-success-dialog p {
  margin: 10px 0 20px;
  color: #71808e;
  font-size: 13px;
  line-height: 1.7;
}
.purchase-success-dialog button {
  width: 100%;
  height: 44px;
  color: #fff;
  border: 0;
  background: #1769b0;
  border-radius: 22px;
  font-size: 15px;
  font-weight: 700;
}
.contract-confirm {
  position: sticky;
  bottom: 0;
  width: 100%;
  height: 46px;
  margin-top: 20px;
  color: #fff;
  border: 0;
  background: #1769b0;
  border-radius: 23px;
  font-size: 15px;
  font-weight: 700;
}
.register_block_list {
  width: 100%;
  height: 50px;
  padding: 0 15px;
  background: #f1f1f3;
  border-radius: 5px;
  display: flex;
  align-items: center;
  font-size: 14px;
  margin-top: 15px;
}
.register_code_lists {
  border: 1px solid #007aff;
  text-align: center;
  color: #007aff;
  border-radius: 6px;
  width: 36%;
  height: 45px;
  margin-left: 15px;
  line-height: 45px;
}
.register_code_list {
  width: 100%;
  height: 50px;
  padding: 0 15px;
  background: #f1f1f3;
  border-radius: 5px;
  display: flex;
  align-items: center;
  font-size: 14px;
}
.register_code {
  display: flex;
  align-items: center;
  margin-top: 15px;
}
.register_tit {
  background: #fff;
  display: flex;
  align-items: center;
  position: relative;
  justify-content: center;
  padding: 5px;
}
.register_tit img {
  width: 30px;
  height: 30px;
  position: absolute;
  left: 15px;
}
.register_tit p {
  text-align: center;
  text-align: center;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #343434;
  line-height: 35px;
}
/* 清除浮动*/
.am-fl {
  float: left;
}
.am-fr {
  float: right;
}
.am-cf:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.am-cf {
  zoom: 1;
}
</style>

